import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@jem-open/jem-ui";
import { ReportScope } from "../services/model/ReportScope";
import ReportWizardBody from "./ReportWizardBody";

export interface ReportWizardDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  scope: ReportScope;
}

const ReportWizardDialog = ({
  open,
  onOpenChange,
  scope,
}: ReportWizardDialogProps): JSX.Element => {
  const contextLabel = scope.kind;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-2rem)] sm:w-full sm:max-w-[560px] max-h-[90vh] overflow-y-auto">
        <DialogHeader className="mb-md">
          <DialogTitle className="text-lg font-semibold text-greyscale-text-title">
            Download Report
          </DialogTitle>
          <DialogDescription className="text-sm text-greyscale-text-body">
            Pre-scoped to this {contextLabel}. Pick a report type and set
            filters.
          </DialogDescription>
        </DialogHeader>
        <ReportWizardBody
          scope={scope}
          onCancel={() => onOpenChange(false)}
          onDownloadComplete={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ReportWizardDialog;
